import { addLocale } from 'primereact/api';

const registerCalendarLocale = (t, lang) => {
    const tc = (key) => t(`calendar.${key}`, { lng: lang }); // helper
    const dayNamesMin = t('calendar.dayNamesMin', {
        lng: lang,
        returnObjects: true, //  esto permite devolver el array completo
    });

    addLocale(lang, {
        firstDayOfWeek: 1,
        showMonthAfterYear: true,

        dayNames: [
            tc('Sunday'),
            tc('Monday'),
            tc('Tuesday'),
            tc('Wednesday'),
            tc('Thursday'),
            tc('Friday'),
            tc('Saturday'),
        ],
        dayNamesShort: [
            tc('Sunday').slice(0, 3),
            tc('Monday').slice(0, 3),
            tc('Tuesday').slice(0, 3),
            tc('Wednesday').slice(0, 3),
            tc('Thursday').slice(0, 3),
            tc('Friday').slice(0, 3),
            tc('Saturday').slice(0, 3),
        ],
        dayNamesMin,
        monthNames: [
            tc('January'),
            tc('February'),
            tc('March'),
            tc('April'),
            tc('May'),
            tc('June'),
            tc('July'),
            tc('August'),
            tc('September'),
            tc('October'),
            tc('November'),
            tc('December'),
        ],
        monthNamesShort: [
            tc('January').slice(0, 3),
            tc('February').slice(0, 3),
            tc('March').slice(0, 3),
            tc('April').slice(0, 3),
            tc('May').slice(0, 3),
            tc('June').slice(0, 3),
            tc('July').slice(0, 3),
            tc('August').slice(0, 3),
            tc('September').slice(0, 3),
            tc('October').slice(0, 3),
            tc('November').slice(0, 3),
            tc('December').slice(0, 3),
        ],

        today: tc('Today') || 'Today',
        clear: tc('Clear') || 'Clear',

        chooseDate: tc('Choose date') || 'Choose date',
        chooseMonth: tc('Choose month') || 'Choose month',
        chooseYear: tc('Choose year') || 'Choose year',
        prevMonth: tc('Previous month') || 'Previous month',
        nextMonth: tc('Next month') || 'Next month',
        prevYear: tc('Previous year') || 'Previous year',
        nextYear: tc('Next year') || 'Next year',
        weekHeader: tc('Week') || 'Week',

        dateFormat: 'dd.mm.yy',
    });
};

export const loadAllCalendarLocales = (t) => {
    const supportedLangs = ['es', 'en', 'de', 'fr', 'it', 'pt'];
    supportedLangs.forEach((lang) => registerCalendarLocale(t, lang));
};

export const loadCalendarLocale = registerCalendarLocale;
